import { createTheme } from '@mui/material';

const baseTheme = createTheme({
  palette: {
    primary: {
      main: '#1976d2', // Azul moderno para elementos principais
      light: '#63a4ff', // Azul claro para hover ou destaque
      dark: '#004ba0',  // Azul escuro para estados ativos
      contrastText: '#ffffff', // Texto claro sobre cores primárias
    },
    secondary: {
      main: '#e53935', // Vermelho moderno para elementos de alerta ou ação secundária
      light: '#ff6f60',
      dark: '#ab000d',
      contrastText: '#ffffff', // Texto claro sobre cores secundárias
    },
    background: {
      default: '#f4f6f8', // Fundo claro para toda a aplicação
      paper: '#ffffff',   // Fundo dos componentes `Paper`
    },
    text: {
      primary: '#2e3b4e', // Texto principal em um tom escuro para boa legibilidade
      secondary: '#65748b', // Texto secundário em um tom mais suave
    },
  },
  typography: {
    fontFamily: 'PFDinTextCompPro-Medium, Arial, sans-serif',
    // fontFamily: '"Barlow Condensed", "Poppins", "Raleway", Arial, sans-serif',
    h1: {
      fontSize: '3.5rem',
      fontWeight: 100,
      letterSpacing: '-0.03em',
    },
    h2: {
      fontSize: '2.5rem',
      fontWeight: 200,
    },
    body1: {
      fontSize: '1.2rem',
      fontWeight: 200,
      lineHeight: 1.5,
    },
    body2: {
      fontSize: '0.95rem',
      fontWeight: 300,
    },
    button: {
      textTransform: 'none',
      fontWeight: 400,
    },
    caption: {
      fontSize: '0.8rem',
      fontWeight: 300,
    },
  },
  spacing: 8, // Define um padrão de espaçamento (8px)
  shape: {
    borderRadius: 8, // Bordas arredondadas para todos os componentes
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          overflowY: 'scroll', // Mantém a barra de rolagem visível
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          fontFamily: 'PFDinTextCompPro-Medium, Arial, sans-serif',
          // fontFamily: 'Roboto, Arial, sans-serif', 
          backgroundColor: '#1565c0', 
          padding: '10px 20px', // Espaçamento interno dos botões
          borderRadius: '8px', // Bordas arredondadas
          boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)', // Sombra para botões
          transition: 'all 0.3s ease', // Suavidade nas transições de hover e click
          '&:hover': {
            backgroundColor: '#0d47a1',
          },
          '&:focus-visible, &:focus, &:active': {
            outline: 'none !important', // Remove permanentemente o outline
            boxShadow: 'none', // Remove também qualquer box-shadow que possa aparecer
          },
        },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          '&:focus-visible, &:focus, &:active': {
            outline: 'none !important', // Remove permanentemente o outline
            boxShadow: 'none', // Remove também qualquer sombra
          },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          padding: '16px', // Padding padrão para componentes Paper
          borderRadius: '8px', // Borda arredondada
          boxShadow: '0px 3px 6px rgba(0, 0, 0, 0.1)', // Sombra suave
        },
      },
    },
    MuiTextField: {
      defaultProps: {
        variant: 'filled', // Define a variante "filled" como padrão para os TextFields
      },
      styleOverrides: {
        root: {
          fontFamily: 'PFDinTextCompPro-Medium, Arial, sans-serif',
          // fontFamily: 'Roboto, Arial, sans-serif', 
          '& .MuiFilledInput-root': {
            backgroundColor: '#ffffff', // Define o fundo branco do TextField
            borderRadius: '8px', // Aplica bordas arredondadas
            boxShadow: 'none', // Remove sombra
            '&:hover': {
              backgroundColor: '#f0f0f0', // Altera a cor de fundo no hover
            },
            '&:before, &:after': {
              borderBottom: 'none', // Remove bordas inferiores no estado padrão e focado
            },
            '&.Mui-focused': {
              backgroundColor: '#ffffff', // Mantém o fundo branco quando focado
            },
          },
        },
      },
    },
    MuiListItemText: {
      styleOverrides: {
        primary: {
          // Estiliza o texto principal
          fontFamily: 'PFDinTextCompPro-Medium, Arial, sans-serif',
          // fontFamily: 'Roboto, Arial, sans-serif', 
          fontWeight: 'bold',
          color: 'gray',
          fontSize: 34,
        },
        secondary: {
          // Estiliza o texto secundário, se houver
          fontFamily: 'PFDinTextCompPro-Medium, Arial, sans-serif',
          // fontFamily: 'Roboto, Arial, sans-serif', 
          color: 'white',
        },
      },
    },
    MuiSwitch: {
      styleOverrides: {
        switchBase: {
          // Cor quando o switch está ativo
          color: 'black',
          transform: 'translate(4.5px,4.5px)',
          '&.Mui-checked': {
            color: '#ffffff',
            transform: 'translate(23.7px,4.8px)',
          },
          '&.Mui-checked + .MuiSwitch-track': {
            backgroundColor: '#F51B01',
            opacity: 1, 
            boxShadow: 'none',
            borderRadius: 16 / 2,
            transition: 'background-color 0.3s ease',
          },
        },
        thumb: {
          width: 11,
          height: 11,  
        },
        track: {
          // Cor do track (trilho) quando o switch está desligado
          backgroundColor: '#ffdc00',
          opacity: 1, // Garantir que a cor não tenha transparência
          boxShadow: 'none', // Remover qualquer sombra que possa escurecer o track
          borderRadius: 16 / 2, // Ajustar o estilo arredondado
          transition: 'background-color 0.3s ease', 
        },
      },
    },
  },
});

export default baseTheme
